<template>
  <div>
    <v-row>
      <v-col cols="12">
        <validation-provider v-slot="{ errors }" rules="required">
          <v-text-field id="titulo-validacao-contabil" v-model="nome" label="Título*" outlined :error-messages="errors" />
        </validation-provider>
      </v-col>
    </v-row>

    <v-row id="select-teste-validacao-contabil">
      <v-col cols="12" sm="6" md="3">
        <v-checkbox v-model="testes.ros" label="Teste ROS" />
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-checkbox v-model="testes.roa" label="Teste ROA" />
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-checkbox v-model="testes.razaoAis" label="Teste Razão x AIS" />
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-checkbox v-model="testes.ais" label="Teste AIS" />
      </v-col>
    </v-row>

    <v-row v-if="mostrarAisFiltros" class="mx-auto">
      <v-col id="database-ais-simulacao" cols="12" md="5">
        <date-picker v-model="aisDatabase" label="AIS Database" type="month" rules="required|min:7" />
      </v-col>

      <v-col class="pb-0 pt-5 text-center" cols="12" md="2"></v-col>

      <v-col id="data-referencia-ais" cols="12" md="5">
        <v-menu v-model="menuReferencia" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <validation-provider v-slot="{ errors }" rules="required">
              <v-text-field
                v-model="dataReferenciaFormatada"
                v-bind="attrs"
                label="Data Referência"
                prepend-icon="mdi-calendar"
                clearable
                :error-messages="errors"
                readonly
                title="Pegará informações a partir desta data"
                v-on="on"
                @click:clear="dataReferencia = ''"
              />
            </validation-provider>
          </template>
          <v-date-picker v-model="dataReferencia" locale="pt-br" @input="menuReferencia = false" />
        </v-menu>
      </v-col>
    </v-row>

    <v-row v-if="mostrarDataImobilizacao" id="data-imobilizacao" class="mx-auto">
      <v-col class="pb-0 pt-1" cols="12" md="5">
        <v-menu v-model="menuInicio" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <validation-provider v-slot="{ errors }" rules="required">
              <v-text-field
                v-model="dataImobilizacaoInicioFormatada"
                v-bind="attrs"
                label="Data Imobilização"
                prepend-icon="mdi-calendar"
                clearable
                :error-messages="errors"
                readonly
                v-on="on"
                @click:clear="dataImobilizacaoInicio = ''"
              />
            </validation-provider>
          </template>

          <v-date-picker v-model="dataImobilizacaoInicio" locale="pt-br" @input="menuInicio = false" />
        </v-menu>
      </v-col>

      <v-col class="pb-0 pt-5 text-center" cols="12" md="2">
        <span class="text--secondary">até</span>
      </v-col>

      <v-col class="pb-0 pt-1" cols="12" md="5">
        <v-menu v-model="menuFim" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <validation-provider v-slot="{ errors }" rules="required">
              <v-text-field
                v-model="dataImobilizacaoFimFormatada"
                v-bind="attrs"
                label="Data Imobilização"
                prepend-icon="mdi-calendar"
                clearable
                :error-messages="errors"
                readonly
                v-on="on"
                @click:clear="dataImobilizacaoFim = ''"
              />
            </validation-provider>
          </template>

          <v-date-picker v-model="dataImobilizacaoFim" locale="pt-br" @input="menuFim = false" />
        </v-menu>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    components: {
      DatePicker: () => import('@/components/general/DatePicker.vue')
    },

    props: {
      items: {
        type: Object,
        default: () => {}
      }
    },

    data() {
      return {
        nome: '',
        testes: {
          ros: false,
          roa: false,
          razaoAis: false,
          ais: false
        },
        menuInicio: false,
        menuFim: false,
        menuReferencia: false,
        dataImobilizacaoInicio: '',
        dataImobilizacaoFim: '',
        aisDatabase: '',
        dataReferencia: ''
      };
    },

    computed: {
      dataImobilizacaoInicioFormatada() {
        if (!this.dataImobilizacaoInicio) return '';
        const [ano, mes, dia] = this.dataImobilizacaoInicio.split('-');
        return `${dia}/${mes}/${ano}`;
      },

      dataImobilizacaoFimFormatada() {
        if (!this.dataImobilizacaoFim) return '';
        const [ano, mes, dia] = this.dataImobilizacaoFim.split('-');
        return `${dia}/${mes}/${ano}`;
      },

      dataReferenciaFormatada() {
        if (!this.dataReferencia) return '';
        const [ano, mes, dia] = this.dataReferencia.split('-');
        return `${dia}/${mes}/${ano}`;
      },

      mostrarDataImobilizacao() {
        return this.testes.ros || this.testes.roa || this.testes.razaoAis;
      },

      mostrarAisFiltros() {
        return this.testes.ais || this.testes.razaoAis;
      }
    },
    mounted() {
      if (this.$route.params.id) {
        this.fillFields();
      }
    },

    methods: {
      formatarData(data) {
        if (!data) return '';
        const [ano, mes, dia] = data.split('-');
        return `${dia}/${mes}/${ano}`;
      },

      exportData() {
        return {
          nome: this.nome,
          data_imobilizacao_inicial: this.dataImobilizacaoInicio ? this.dataImobilizacaoInicio : '',
          data_imobilizacao_final: this.dataImobilizacaoFim ? this.dataImobilizacaoFim : '',
          ais_database: this.aisDatabase ? this.aisDatabase : '',
          data_referencia: this.dataReferencia ? this.dataReferencia : '',
          testes: this.testes
        };
      },

      fillFields() {
        let validacao = this.items;
        this.nome = validacao.nome;
        const testes = validacao.testes ? JSON.parse(validacao.testes) : {};

        this.testes = {
          ros: Boolean(testes.ros),
          roa: Boolean(testes.roa),
          razaoAis: Boolean(testes.razaoAis),
          ais: Boolean(testes.ais)
        };

        this.dataImobilizacaoInicio = validacao.data_imobilizacao_inicial
          ? validacao.data_imobilizacao_inicial.split('T')[0]
          : '';
        this.dataImobilizacaoFim = validacao.data_imobilizacao_final ? validacao.data_imobilizacao_final.split('T')[0] : '';
        this.aisDatabase = validacao.ais_database ? validacao.ais_database.split('T')[0] : '';
        this.dataReferencia = validacao.data_referencia ? validacao.data_referencia.split('T')[0] : '';
      }
    },

    watch: {
      mostrarDataImobilizacao(value) {
        if (!value) {
          this.dataImobilizacaoInicio = '';
          this.dataImobilizacaoFim = '';
        }
      },

      mostrarAisFiltros(value) {
        if (!value) {
          this.aisDatabase = '';
          this.dataReferencia = '';
        }
      },

      items() {
        this.fillFields();
      }
    }
  };
</script>
